/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

// Multipolygon coordinates
export const findSmallestMultiPolygonFirstChild = (
  multiPolygons: number[][][][],
): number => {
  const smallestValues = multiPolygons.map((polygon: number[][][]) => {
    const smallFirsts = polygon.map((pairs: number[][]) =>
      Math.min(...pairs.map(([first]) => first)),
    );
    return Math.min(...smallFirsts);
  });
  return Math.min(...smallestValues);
};

export const findLargestMultiPolygonFirstChild = (
  multiPolygons: number[][][][],
): number => {
  const largestValues = multiPolygons.map((polygon: number[][][]) => {
    const largeFirsts = polygon.map((pairs: number[][]) =>
      Math.max(...pairs.map(([first]) => first)),
    );
    return Math.max(...largeFirsts);
  });
  return Math.max(...largestValues);
};

export const findSmallestMultiPolygonLastChild = (
  multiPolygons: number[][][][],
): number => {
  const smallestValues = multiPolygons.map((polygon: number[][][]) => {
    const smallFirsts = polygon.map((pairs: number[][]) =>
      Math.min(...pairs.map(([, last]) => last)),
    );
    return Math.min(...smallFirsts);
  });
  return Math.min(...smallestValues);
};

export const findLargestMultiPolygonLastChild = (
  multiPolygons: number[][][][],
): number => {
  const largestValues = multiPolygons.map((polygon: number[][][]) => {
    const largeFirsts = polygon.map((pairs: number[][]) =>
      Math.max(...pairs.map(([, last]) => last)),
    );
    return Math.max(...largeFirsts);
  });
  return Math.max(...largestValues);
};

// Polygon coordinates
export const findSmallestPolygonFirstChild = (pairs: number[][][]): number => {
  return Math.min(...pairs[0].map(([first]) => first));
};

export const findLargestPolygonFirstChild = (pairs: number[][][]): number => {
  return Math.max(...pairs[0].map(([first]) => first));
};

export const findSmallestPolygonLastChild = (pairs: number[][][]): number => {
  return Math.min(...pairs[0].map(([, last]) => last));
};

export const findLargestPolygonLastChild = (pairs: number[][][]): number => {
  return Math.max(...pairs[0].map(([, last]) => last));
};
